import { render, staticRenderFns } from "./InputTags.vue?vue&type=template&id=12fe54cd&scoped=true"
import script from "./InputTags.vue?vue&type=script&lang=js"
export * from "./InputTags.vue?vue&type=script&lang=js"
import style0 from "./InputTags.vue?vue&type=style&index=0&id=12fe54cd&prod&lang=scss&scoped=true"
import style1 from "./InputTags.vue?vue&type=style&index=1&id=12fe54cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fe54cd",
  null
  
)

export default component.exports